<script>
import {defineComponent} from 'vue'
import {getLocalStorage, setLocalStorage} from "@js/helpers.ts";
import {Link} from "@inertiajs/vue3";

export default defineComponent({
    name: "CookieAccept",
    components: {Link},
    data() {
        return {
            show: false,
        }
    },
    methods: {
        acceptCookie() {
            this.show = false
        },
        checkCookie() {
            return getLocalStorage('cookie_accepted') === '1'
        }
    },
    mounted() {
        if (!this.checkCookie()) {
            const vm = this
            setTimeout(function () {
                vm.show = true
                setLocalStorage('cookie_accepted', '1', 525600) // на год
            }, 2000)
        }
    }
})
</script>

<template>
    <transition name="cookie-slide">
        <div v-if="show"
             class="shadow z-20 fixed inset-x-0 bottom-0 md:start-6 md:bottom-6 md:max-w-[450px] bg-white border-baseColor border-2 rounded-t-lg md:rounded-b-lg p-5">
            <div class="text-xs max-md:font-medium">
                Нажимая кнопку «Принимаю», вы даёте
                <a :href="route('privacyPolicy')" target="_blank" @click="acceptCookie"
                   class="md:hover:text-baseColor underline underline-offset-2 transition">
                    согласие на обработку ваших персональных данных
                </a>
                , собираемых с
                помощью файлов cookie и сервисов сбора технических данных посетителей, с целью предоставления
                персонализированного доступа к контенту и сервисам Сайта...
            </div>
            <div class="mt-5 flex items-center justify-end">
                <button @click.prevent="acceptCookie" type="button"
                        class="w-full md:w-auto text-white hover:text-baseColor border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-medium rounded-lg text-sm px-14 py-2 focus:outline-none transition">
                    Принимаю
                </button>
            </div>
        </div>
    </transition>
</template>

<style scoped lang="scss">
.cookie-slide-enter-active,
.cookie-slide-leave-active {
    transition: transform 0.3s ease-out;
}

.cookie-slide-enter-from,
.cookie-slide-leave-to {
    transform: translateY(100%);
}

.cookie-slide-enter-to,
.cookie-slide-leave-from {
    transform: translateY(0);
}
</style>
